export default "__VITE_ASSET__CJvIowtd__"